import { render, staticRenderFns } from "./beautiful.vue?vue&type=template&id=9b127ec6"
import script from "./beautiful.vue?vue&type=script&lang=js"
export * from "./beautiful.vue?vue&type=script&lang=js"
import style0 from "./beautiful.vue?vue&type=style&index=0&id=9b127ec6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports